package xim.poc.game.configuration.v0.behaviors

import xim.math.Vector3f
import xim.poc.ActorController
import xim.poc.DefaultEnemyController
import xim.poc.game.ActorState
import xim.poc.game.ActorStateManager
import xim.poc.game.CombatBonusAggregate
import xim.poc.game.GameState
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.constants.mskillPhototrophicBlessing_2724
import xim.poc.game.configuration.constants.mskillPhototrophicWrath_2725
import xim.poc.velocityVectorTo
import xim.resource.TargetFlag

class MobFriendlyLeafkinBehavior(actorState: ActorState): V0MonsterController(actorState) {

    override fun wantsToUseSkill(): Boolean {
        return if (!actorState.isEngaged()) { true } else { super.wantsToUseSkill() }
    }

    override fun applyMonsterBehaviorBonuses(aggregate: CombatBonusAggregate) {
        if (!actorState.isEngaged()) { aggregate.regain += 30 }
    }

    override fun getSkillEffectedTargetType(skillId: SkillId): Int? {
        if (actorState.isEngaged()) { return super.getSkillEffectedTargetType(skillId) }

        return if (skillId == mskillPhototrophicBlessing_2724 || skillId == mskillPhototrophicWrath_2725) {
            TargetFlag.Self.flag or TargetFlag.Enemy.flag
        } else {
            super.getSkillEffectedTargetType(skillId)
        }
     }

}

class MobFriendlyFollowMovementController: ActorController {

    private val delegate = DefaultEnemyController()

    override fun getVelocity(actorState: ActorState, elapsedFrames: Float): Vector3f {
        if (actorState.isEngaged()) { return delegate.getVelocity(actorState, elapsedFrames) }

        val player = ActorStateManager.player()
        if (actorState.getTargetingDistance(player) < 2f) { return Vector3f.ZERO }

        val desiredPosition = GameState.getGameMode().pathNextPosition(actorState, elapsedFrames, player.position) ?: player.position
        return velocityVectorTo(actorState.position, desiredPosition, actorState.getMovementSpeed(), elapsedFrames)
    }

}